import { ActionReducerZoneAdministration, StateZoneAdministration } from '../interfaces/Administration';

export const selectedItemsZAdminReducer = (state: StateZoneAdministration, action: ActionReducerZoneAdministration): StateZoneAdministration => {
    if (action.type === 'ADD_BEDS') {
        if (state.addBedIDs.includes(action.payload))
            return { ...state, addBedIDs: state.addBedIDs.filter(item => item !== action.payload) };
        else return { ...state, addBedIDs: [...state.addBedIDs, action.payload] };
    }
    else if (action.type === 'ADD_TOWNS' && action.payload !== undefined) {
        if (state.addTownIDs.includes(action.payload))
            return { ...state, addTownIDs: state.addTownIDs.filter(item => item !== action.payload) };
        else return { ...state, addTownIDs: [...state.addTownIDs, action.payload] };
    }
    else if (action.type === 'RESET_ADD') return { ...state, addBedIDs: [], addTownIDs: [] };
    if (action.type === 'REMOVE_BEDS') {
        if (state.removeBedIDs.includes(action.payload))
            return { ...state, removeBedIDs: state.removeBedIDs.filter(item => item !== action.payload) };
        else return { ...state, removeBedIDs: [...state.removeBedIDs, action.payload] };
    }
    else if (action.type === 'REMOVE_TOWNS' && action.payload !== undefined) {
        if (state.removeTownIDs.includes(action.payload))
            return { ...state, removeTownIDs: state.removeTownIDs.filter(item => item !== action.payload) };
        else return { ...state, removeTownIDs: [...state.removeTownIDs, action.payload] };
    }
    else if (action.type === 'RESET_REMOVE') return { ...state, removeBedIDs: [], removeTownIDs: [] };
    return state;
};
